import { PRIMARY_FONT } from '../../theme/fontConstants';
import theme from '../../theme/theme';

export const modalStyle = {
  position: 'absolute',
  top: { xs: '16px', lg: '50%' },
  left: '50%',
  transform: { xs: 'translateX(-50%)', lg: 'translate(-50%, -50%)' },
  width: { xs: '96%', lg: theme.components.recommendWorkerModal.layout.modal.width },
  maxWidth: theme.components.recommendWorkerModal.layout.modal.maxWidth,
  height: { xs: 'calc(100dvh - 32px)', lg: 'auto' },
  maxHeight: {
    xs: 'calc(100dvh - 32px)',
    lg: theme.components.recommendWorkerModal.layout.modal.maxHeight,
  },
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: theme.components.recommendWorkerModal.layout.modal.borderRadius,
  p: { xs: 2, lg: theme.components.recommendWorkerModal.layout.modal.padding },
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const headerStyle = {
  fontSize: theme.components.recommendWorkerModal.typography.header.fontSize,
  fontFamily: theme.components.recommendWorkerModal.typography.header.fontFamily,
  width: '150px',
};

export const maxRequestNumReachedStyle = {
  fontSize: theme.components.recommendWorkerModal.typography.caption.fontSize,
  fontFamily: theme.components.recommendWorkerModal.typography.caption.fontFamily,
  color: theme.components.recommendWorkerModal.palette.title.fontColor,
};

export const cardStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  marginBottom: theme.components.recommendWorkerModal.layout.card.marginBottom,
};

export const filterInputStyle = {
  '& .MuiOutlinedInput-notchedOutline': {
    border: '0px',
  },
  '& .MuiInputBase-input::placeholder': {
    color: theme?.button?.palette?.primary,
    fontFamily: PRIMARY_FONT['400'],
    opacity: 1,
  },
  border: `1px solid ${theme?.searchBoxForFilter?.borderColor?.focus}`,
  borderRadius: '5px',
  justifyContent: 'center',
  height: '28px',
  width: '200px',
};
